export const MOBILE_NUMBER_REGEX = /^[6-9][0-9]{9}$/
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/
export const NAME_REGEX = /^[A-Za-z\s]*$/
export const ID_REGEX = /^[a-zA-Z ]+@(zet)$/
export const PINCODE_REGEX = /^[1-8][0-9]{5}$/
export const DISTRICT_STATE_NAME_REGEX = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/

export const PAN_REGEX = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/
export const OTP_REGEX = /^\d{0,4}$/
export const SUBDOMAIN_REGEX = /^(?!-)[a-zA-Z0-9-]{1,63}(?<!-)$/
export const BUSINESS_NAME_REGEX = /^[a-zA-Z0-9 ]+$/
